/** Format ISO datetime for display in a given IANA timezone. */
export function formatSlotTime(iso, timeZone) {
  if (!iso) return '';
  const date = new Date(iso);
  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: timeZone || undefined,
  }).format(date);
}

export function formatSlotDateTime(iso, timeZone) {
  if (!iso) return '';
  const date = new Date(iso);
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: timeZone || undefined,
  }).format(date);
}

export function formatTimezoneLabel(timeZone) {
  if (!timeZone) return '';
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'short',
    }).formatToParts(new Date());
    const tzName = parts.find(p => p.type === 'timeZoneName')?.value;
    return tzName ? `${timeZone.replace(/_/g, ' ')} (${tzName})` : timeZone.replace(/_/g, ' ');
  } catch {
    return timeZone.replace(/_/g, ' ');
  }
}

/** YYYY-MM-DD for today (local) plus offset days. */
export function dateOffsetIso(offsetDays = 0) {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + offsetDays);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export const AVAILABILITY_RANGE_DAYS = 21;

export function defaultAvailabilityRange() {
  return {
    from: dateOffsetIso(0),
    to: dateOffsetIso(AVAILABILITY_RANGE_DAYS),
  };
}
